/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 400223cd0f5cd70ad99fb8cbb5d153e9 */

import { ConcreteRequest } from "relay-runtime";
export type UserAddAddressInput = {
    userId: string;
    validateBuyerShipping?: boolean | null | undefined;
    transactionId?: string | null | undefined;
    shipmentQuoteId?: string | null | undefined;
    address: AddressInput;
    mockAddressBook?: boolean | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type AddressInput = {
    active?: boolean | null | undefined;
    addressBookMember?: boolean | null | undefined;
    contact?: string | null | undefined;
    city?: string | null | undefined;
    company?: string | null | undefined;
    country?: string | null | undefined;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    label?: string | null | undefined;
    line1?: string | null | undefined;
    line2?: string | null | undefined;
    phoneNumber?: string | null | undefined;
    state?: string | null | undefined;
    zipCode?: string | null | undefined;
};
export type dblUserAddAddressMutationVariables = {
    input: UserAddAddressInput;
};
export type dblUserAddAddressMutationResponse = {
    readonly userAddAddress: {
        readonly address: {
            readonly serviceId: string | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
        } | null;
    } | null;
};
export type dblUserAddAddressMutation = {
    readonly response: dblUserAddAddressMutationResponse;
    readonly variables: dblUserAddAddressMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dblUserAddAddressMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserAddAddressPayload",
        "kind": "LinkedField",
        "name": "userAddAddress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dblUserAddAddressMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserAddAddressPayload",
        "kind": "LinkedField",
        "name": "userAddAddress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/352.0.0-2022-02-11T22:12:33.438Z/dblUserAddAddressMutation",
    "metadata": {},
    "name": "dblUserAddAddressMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '07798d83253ef0d6fb8af14aff716c81';
export default node;
